export default {
  addOns: '附加項目',
  availabilityDaySelector: '可用日期選擇器',
  unavailable: '無法使用',
  person: '人',
  people: '人',
  reserveNow: '立即預約',
  selectTime: '選擇時間',
  select: '選擇',
  reserve: '預約',
  time: '時間',
  tier: '層級',
  questions: '問題',
  addToCart: '加入購物車',
  checkout: '結帳',
  total: '總計',
  availability: '可用性',
  whatsIncluded: '包含內容',
  showMore: '顯示更多',
  showLess: '顯示較少',
  session: '場次',
  viewDetails: '查看詳情',
  findAvailability: '查找可用時段',
  loading: '載入中',
  capacity: '容量',
  noAvailableSessionsOnThisDate: '此日期無可用場次',
  noGroupAvailableOnThisDateAndTime: '此日期與時間無可用的 {{groupTitle}}',
  noCollectionFound: '找不到集合！',
  noResourceGroupFound: '找不到資源群組！',
  noData: '無資料！',
  continue: '繼續',
  night: '晚',
  nights: '晚',
  noAvailableSessionsForSelectedDates:
    '您選擇的某些日期沒有可用場次。請選擇其他日期。',
  from: '從',
  dateRangeSelector: '日期範圍選擇器',
  priceTierRadioGroup: '價格層級選擇器',
  startTime: '開始時間',
  duration: '時長',
  lengthOfStay: '入住時長',
  startDate: '開始日期',
  endDate: '結束日期',
  selectDates: '選擇日期',
  more: '更多',
  selectStartTime: '選擇開始時間',
  endTime: '結束時間',
  selectEndTime: '選擇結束時間',
  morning: '上午',
  afternoon: '下午',
  save: '儲存',
  selectDuration: '選擇時長',
  forLength: '{{length}}',
  moreDates: '還有 {{count}} 個',
  addDate: '新增日期',
  start: '開始',
  end: '結束',
  pickupFrom: '最早取件',
  returnBy: '最晚歸還',
  day: '天',
  days: '天',
  hour: '小時',
  hours: '小時',
};
